import React, { Component } from "react";
import axios from "axios";
// import {Link} from 'react-router-dom';
import domain from "./domain";
import { Button } from "mdbreact";
// import moment from 'moment-timezone'
import Dropzone from "react-dropzone";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "mdbreact";
var validExt = ".png, .jpeg, .jpg";
//function for validate file size
var maxSize = "3072";
export default class EditProfile extends Component {
  constructor() {
    super();
    this.state = {
      completed: new Set(),

      department: null,
      designation: null,
      project: null,
      roles: null,
      activeStep: 0,
      skipped: new Set(),
      empcode: null,
      name: null,
      empdepartment: null,
      empdesignation: null,
      empproject: [],
      emprole: null,
      fndesg: null,
      mobile: null,
      landline: "",
      email: null,
      username: null,
      password: null,
      confpassword: null,
      photo: null,
      uploaded: 0,
      file: null,
      modal: false,
      doj: null,
      dbusername: null,
      employee_details: null,

      employee_all_details: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDrop = this.onDrop.bind(this);

    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  onDrop([file]) {
    this.setState({
      file: file,
    });
  }

  async fetchDeptDesgProjRoles() {
    let result = await axios.all([
      axios.get(`${domain.DBServer}/fetch-department`),
      axios.get(`${domain.DBServer}/fetch-designation`),
      axios.get(`${domain.DBServer}/fetch-project`),
      axios.get(`${domain.DBServer}/fetch-roles`),
    ]);

    if (result) {
      this.setState({
        department: result[0].data,
        designation: result[1].data,
        project: result[2].data,
        roles: result[3].data,
      });
    } else {
      alert("Network Error");
    }
  }

  componentDidMount() {
    this.fetchDeptDesgProjRoles();
    let y,
      day,
      m,
      d,
      finaldate,
      activities = [];
    if (this.props.emp_details[0].doj) {
      d = new Date(this.props.emp_details[0].doj);
      day = ("0" + d.getDate()).slice(-2);
      m = ("0" + (d.getMonth() + 1)).slice(-2);
      y = d.getFullYear();
      finaldate = y + "-" + m + "-" + day;
    }

    if (this.props.employee_all_activities != null) {
      this.props.employee_all_activities.map((employee, key) => {
        activities[key] = employee.activity_id;
        return true;
      });
    }

    this.setState({
      empcode: this.props.emp_details[0].employee_id,
      empdesignation: this.props.emp_details[0].desgn_id,
      empdepartment: this.props.emp_details[0].dep_id,
      email: this.props.emp_details[0].email,
      mobile: this.props.emp_details[0].mobile,
      landline: this.props.emp_details[0].landline,
      emprole: this.props.emp_details[0].project_role_id,
      empproject: activities,
      fndesg: this.props.emp_details[0].fndesg,
      file: this.props.emp_details[0].photo,
      doj: finaldate,
    });
  }

  handleProjectChange = (e) => {
    var options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({
      empproject: value,
    });
  };
  handleChange = (e) => {
    e.preventDefault();
    e = e.target;
    this.setState({
      [e.name]: e.value,
    });
  };

  validateFile = (photo) => {
    if (this.fileExtValidate(photo) && this.fileSizeValidate(photo))
      return true;
    else return false;
  };

  fileExtValidate = (fdata) => {
    var filePath = fdata.name;

    var getFileExt = filePath
      .substring(filePath.lastIndexOf(".") + 1)
      .toLowerCase();
    var pos = validExt.indexOf(getFileExt);
    if (pos < 0) {
      alert(
        "This file is not allowed, please upload valid file. Allowed file formats are .png , .jpg,.jpeg"
      );
      return false;
    } else {
      return true;
    }
  };

  fileSizeValidate = (fdata) => {
    if (fdata.size) {
      var fsize = fdata.size / 1024;
      // alert(fsize)
      if (fsize > maxSize) {
        alert(
          "Maximum file size exceeds, Allowed file size is: " + fsize + "KB"
        );
        return false;
      } else {
        return true;
      }
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let r = window.confirm("Are you want to update the details ");
    if (!r) return false;
    if (this.state.file === this.props.emp_details[0].photo) {
      alert("You have not changed your photo ");
      if (
        this.state.empcode &&
        this.state.empdesignation &&
        this.state.empdepartment &&
        this.state.doj &&
        this.state.empproject &&
        this.state.emprole &&
        this.state.mobile &&
        this.state.email
      ) {
        var data = new FormData();
        let employee_details = {
          empcode: this.state.empcode,
          empdesignation: this.state.empdesignation,
          empdepartment: this.state.empdepartment,
          empproject: [this.state.empproject],
          emprole: this.state.emprole,
          empdoj: this.state.doj,
          empemail: this.state.email,
          empmobile: this.state.mobile,
          emplandline: this.state.landline,
          empfuncdesg: this.state.fndesg,
        };

        data.append("photo", this.state.file);

        if (employee_details) {
          for (let key in employee_details) {
            data.append(key, employee_details[key]);
          }
        }
        //  console.log(data.getAll(0))

        axios
          .post(`${domain.DBServer}/update-employee-without-photo-update`, data)
          .then((res) => {
            if (res.data === 1) {
              alert("Details are updated successfully");
              window.location.reload(`/profile/${this.state.empcode}`);
            } else {
              alert("Network error");
            }
          })
          .catch((err) => {
            alert(err);
            this.setState({
              error: err.message,
            });
          });
      }
    } else {
      if (!this.validateFile(this.state.file)) return false;

      if (
        this.state.file &&
        this.state.empcode &&
        this.state.empdesignation &&
        this.state.empdepartment &&
        this.state.doj &&
        this.state.empproject &&
        this.state.emprole &&
        this.state.mobile &&
        this.state.email
      ) {
        data = new FormData();
        let employee_details = {
          empcode: this.state.empcode,

          empdesignation: this.state.empdesignation,
          empdepartment: this.state.empdepartment,
          empproject: [this.state.empproject],
          emprole: this.state.emprole,
          empdoj: this.state.doj,
          empemail: this.state.email,
          empmobile: this.state.mobile,
          emplandline: this.state.landline,
          empfuncdesg: this.state.fndesg,
        };
        console.log(employee_details);

        data.append("photo", this.state.file);
        if (employee_details) {
          for (let key in employee_details) {
            data.append(key, employee_details[key]);
          }
        }
        //console.log(data)
        var config = {
          onUploadProgress: (progressEvent) => {
            this.setState({
              uploaded: progressEvent.loaded / progressEvent.total,
            });
          },
        };

        axios
          .post(`${domain.DBServer}/update-employee`, data, config)
          .then((res) => {
            console.log(res);

            this.setState({
              uploaded: 1,
            });
            if (res.data === 1) {
              alert("Details are updated successfully");
              window.location.reload(`/profile/${this.state.empcode}`);
            } else {
              alert("Network error");
            }
          })
          .catch((err) => {
            alert(err);
            this.setState({
              error: err.message,
            });
          });
      }
    }
  };

  render() {
    let designationoptions, departmentoptions, rolesoptions, projectoptions;

    if (this.state.designation) {
      designationoptions = this.state.designation.map((designation, key) => {
        return (
          <option key={key} value={designation.desgn_id}>
            {designation.title}
          </option>
        );
      });
    }
    if (this.state.department) {
      departmentoptions = this.state.department.map((department, key) => {
        return (
          <option key={key} value={department.dep_id}>
            {department.name}
          </option>
        );
      });
    }
    if (this.state.project) {
      projectoptions = this.state.project.map((project, key) => {
        return (
          <option key={key} value={project.act_id}>
            {project.name}
          </option>
        );
      });
    }
    if (this.state.roles) {
      rolesoptions = this.state.roles.map((role, key) => {
        return (
          <option key={key} value={role.role_id}>
            {role.title}
          </option>
        );
      });
    }

    return (
      <div style={{ fontFamily: "helvetica" }}>
        <Button className="btn btn-secondary float-right" onClick={this.toggle}>
          Edit
        </Button>

        <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg">
          <ModalHeader toggle={this.toggle}>Edit Profile</ModalHeader>
          <ModalBody>
            <form
              className="form-horizontal"
              method="post"
              encType="multipart/form-data"
              onSubmit={this.handleSubmit}
            >
              <div className="row">
                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="name" style={{ fontFamily: "helvetica" }}>
                    Employee Code
                  </label>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    {/* <div className="input-group-addon" style={{width: "2.6rem"}}><i className="fa fa-id-card"></i></div> */}
                    <input
                      disabled
                      autoComplete="on"
                      type="text"
                      name="empcode"
                      className="form-control"
                      id="empcode"
                      required
                      autoFocus
                      onChange={this.handleChange}
                      value={this.state.empcode || ""}
                    />
                  </div>
                </div>

                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="name" style={{ fontFamily: "helvetica" }}>
                    Designation
                  </label>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    {/* <div className="input-group-addon" style={{width: "2.6rem"}}><i className="fa fa-certificate"></i></div> */}
                    <select
                      className="custom-select"
                      id="empdesignation"
                      name="empdesignation"
                      onChange={this.handleChange}
                      value={this.state.empdesignation}
                      selected={this.state.empdesignation}
                    >
                      {designationoptions}
                    </select>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="row">
                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="name" style={{ fontFamily: "helvetica" }}>
                    Department
                  </label>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="custom-select"
                      id="empdepartment"
                      name="empdepartment"
                      onChange={this.handleChange}
                      value={this.state.empdepartment}
                      selected={this.state.empdepartment}
                    >
                      {departmentoptions}
                    </select>
                  </div>
                </div>

                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="name" style={{ fontFamily: "helvetica" }}>
                    Date of Joining in NHP
                  </label>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      autoComplete="on"
                      type="date"
                      name="doj"
                      className="form-control"
                      required
                      autoFocus
                      onChange={this.handleChange}
                      id="doj"
                      value={this.state.doj}
                    />
                  </div>
                </div>
              </div>
              <br />
              <br />

              <div className="row">
                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="name" style={{ fontFamily: "helvetica" }}>
                    Role
                  </label>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="custom-select"
                      name="emprole"
                      id="emprole"
                      onChange={this.handleChange}
                      selected={this.state.emprole}
                      value={this.state.emprole}
                    >
                      {rolesoptions}
                    </select>
                  </div>
                </div>

                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="email" style={{ fontFamily: "helvetica" }}>
                    Functional Designation
                  </label>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      autoComplete="on"
                      type="text"
                      name="fndesg"
                      className="form-control"
                      id="fndesg"
                      placeholder="Enter functional designation"
                      value={this.state.fndesg || ""}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="row">
                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="email" style={{ fontFamily: "helvetica" }}>
                    {" "}
                    Mobile Number
                  </label>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      autoComplete="on"
                      type="tel"
                      name="mobile"
                      className="form-control"
                      id="phone"
                      placeholder="Mobile Number should contain 10 digits"
                      onChange={this.handleChange}
                      value={this.state.mobile}
                      pattern="[0-9]{10}"
                      title="Mobile number must contain 10 digits"
                    />
                  </div>
                </div>

                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="email" style={{ fontFamily: "helvetica" }}>
                    Landline Number
                  </label>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      autoComplete="on"
                      type="text"
                      name="landline"
                      className="form-control"
                      id="landline"
                      placeholder="Ex:040-28334552"
                      value={this.state.landline}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="row">
                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="email" style={{ fontFamily: "helvetica" }}>
                    E-Mail Address
                  </label>
                </div>
                <div className="col-md-8">
                  <div className="form-group">
                    <input
                      autoComplete="on"
                      type="text"
                      name="email"
                      className="form-control"
                      id="email"
                      placeholder="Ex:test@gmail.com/test@nrsc.gov.in"
                      value={this.state.email}
                      required
                      onChange={this.handleChange}
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                      title="characters@characters.domain (characters followed by an @ sign, followed by more characters, and then a ."
                    />
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="row">
                <div className="col-md-2 field-label-responsive">
                  <label
                    htmlFor="empproject"
                    style={{ fontFamily: "helvetica" }}
                  >
                    Project (
                    <i>Use Ctrl + right click for multiple selections</i>)
                  </label>
                </div>
                <div className="col-md-8">
                  <div className="form-group">
                    <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                      <div
                        className="input-group-addon"
                        style={{ width: "2.6rem" }}
                      >
                        <i></i>
                      </div>
                      <select
                        multiple="true"
                        className="custom-select"
                        name="empproject"
                        id="empproject"
                        onChange={this.handleProjectChange}
                        selected={this.state.empproject}
                        value={this.state.empproject}
                      >
                        {projectoptions}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-2 field-label-responsive">
                  <label htmlFor="photo" style={{ fontFamily: "helvetica" }}>
                    Update Photo
                  </label>
                </div>
                <div className="col-md-8 field-label-responsive">
                  <div
                    style={{
                      float: "left",
                      width: "calc(100% - 50px)",
                      textAlign: "center",
                      backgroundColor: "#fafafa",
                      margin: "15px 15px",
                      padding: "15px",
                      boxShadow: "0 0 2px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    <Dropzone
                      multiple={false}
                      ref={(node) => {
                        this.dropzone = node;
                      }}
                      onDrop={this.onDrop}
                      id="photo"
                      style={{
                        height: "150px",
                        borderWidth: 2,
                        borderColor: "rgb(102, 102, 102)",
                        borderStyle: "dashed",
                        borderRadius: 5,
                        margin: "16px auto",
                      }}
                    >
                      Drag and drop a image file to start uploading.
                      <div className="alert alert-warning">
                        The file format can be .png, .jpeg or .jpg. The file
                        size cannot exceed 3MB
                      </div>
                      <Button type="button">Upload Photo</Button>
                      <br />
                      {/* {(this.state.file != null)? <div>
        <h5>Uploading {this.state.file.name} ({(this.state.uploaded * 100).toFixed(2)}%)</h5>
        
        </div> : null} */}
                      <div></div>
                    </Dropzone>
                  </div>
                </div>
              </div>

              {/* </div> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button variant="raised" color="secondary" type="submit">
                  <i className="fa fa-user-plus"></i> Update
                </Button>
              </div>
            </form>
          </ModalBody>

          <ModalFooter>
            <Button color="danger" onClick={this.toggle}>
              Close
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
